module.exports = __webpack_public_path__ + "img/practices_blue.5963ef7d.svg";